import AppConstants from '../constants/AppConstants';
import RouterConstants from '../constants/RouterConstants';
import SearchConstants from '../constants/SearchConstants';

const initialState = false;

export default function internalError(state = initialState, action) {
  switch (action.type) {
    case AppConstants.SHOW_ERROR_PAGE: {
      return true;
    }

    case SearchConstants.SEARCH_FAILURE: {
      return typeof action.payload.status !== 'undefined' && action.payload.status && action.payload.status !== 422;
    }

    case RouterConstants.ROUTER_TRANSITION:
    case RouterConstants.LOCATION_CHANGED: {
      return false;
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/InternalErrorReducer.js